import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

export interface AtomsBreadcrumbOriginLinkSignature {
  Args: {
    originUrl?: string;
    fallbackRoute: string;
    fallbackModel?: string;
    useOrigin?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLAnchorElement;
}

export default class AtomsBreadcrumbOriginLink extends Component<AtomsBreadcrumbOriginLinkSignature> {
  @service declare router: RouterService;

  get showOrigin() {
    const useOrigin = this.args.useOrigin ?? true;
    return useOrigin && Boolean(this.args.originUrl);
  }

  @action
  followOrigin(event: MouseEvent) {
    if (
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.button !== 0
    ) {
      return;
    }
    event.preventDefault();
    this.router.transitionTo(this.args.originUrl as string);
  }
}
